type UnknownRecord = Readonly<Record<string, unknown>>

function isRecord(value: unknown): value is UnknownRecord {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function isFormulaCell(value: unknown): value is UnknownRecord {
  return isRecord(value) && ('formula' in value || 'sharedFormula' in value)
}

/** Best-effort, side-effect-free conversion for headers and text fields. */
export function cellToText(value: unknown): string {
  if (value === null || value === undefined) return ''
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'bigint') {
    return String(value)
  }
  if (typeof value === 'boolean') return value ? 'TRUE' : 'FALSE'
  if (value instanceof Date) return value.toISOString()
  if (!isRecord(value)) return ''

  if (typeof value.text === 'string') return value.text
  if (Array.isArray(value.richText)) {
    return value.richText
      .map((part) => (isRecord(part) && typeof part.text === 'string' ? part.text : ''))
      .join('')
  }
  if (isFormulaCell(value) && 'result' in value) return cellToText(value.result)
  return ''
}
